<template>
    <div class="shapan-container">
        <div class="shapan" v-for="item in shapanList" :key="item.id" @click="toDetail(item)">
            <div class="content">
                <!-- <h1 class="title">{{item.title}}</h1> -->
                <!-- <h1 class="subTitle">{{item.subTitle}}</h1> -->
            </div>
            <img :src="item.src">
        </div>
    </div>
</template>

<script>
export default {
    data() {
        return {
            shapanList: [
                {
                    id: 2,
                    title: '2022虚拟展馆',
                    subTitle: '虚拟展馆',
                    src: 'https://ef-imaster-file.oss-cn-beijing.aliyuncs.com/izt_static/PC/jinrong/activitys_1.png',
                    url: 'https://mp.weixin.qq.com/s/tUAdxe9FBrGbFY2NAKYc9w'
                },
                {
                    id: 1,
                    title: '2020虚拟展馆',
                    subTitle: '虚拟展馆',
                    src: 'https://ef-imaster-file.oss-cn-beijing.aliyuncs.com/izt_static/PC/jinrong/activitys_2.png',
                    url: 'https://mp.weixin.qq.com/s/QkIn2V9NTfIbHELLDJFVtw'
                }
            ]
        }
    },
    methods: {
        toDetail(item) {
            if (!item.url) return
            window.open(item.url, '_self')
            // const el = document.createElement('a')
            // document.body.appendChild(el)
            // el.href = item.url
            // el.target = '_blank' //指定在新窗口打开
            // el.click()
            // document.body.removeChild(el)
        }
    }
}
</script>

<style scoped>
.shapan-container {
    padding: 16px;
    box-sizing: border-box;
    width: 100%;
    max-width: 750px;
    margin: 0 auto;
    position: absolute;
    left: 0;
    top: 0;
    bottom: 0;
    right: 0;
    background: #ffffff;
}
.shapan-container .shapan {
    font-size: 0;
    position: relative;
    margin-bottom: 14px;
}
.shapan-container .shapan .content {
    width: 100%;
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate3d(-50%, -50%, 0);
    color: #ffffff;
    padding: 0 20px;
    box-sizing: border-box;
}
.shapan-container .shapan .content .title, .shapan-container .shapan .content .subTitle {
  width: 100%;
  font-size: 26px;
  color: #ffffff;
  font-weight: normal;
  text-align: center;
  margin: 0;
}
.shapan-container .shapan img {
    width: 100%;
    height: 160px;
    display: inline-block;
    border-radius: 4px;
}

</style>
